import { render } from "./PaperlessClassroom.vue?vue&type=template&id=527ad358&scoped=true"
import script from "./PaperlessClassroom.vue?vue&type=script&lang=js"
export * from "./PaperlessClassroom.vue?vue&type=script&lang=js"

import "./PaperlessClassroom.vue?vue&type=style&index=0&id=527ad358&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527ad358"]])

export default __exports__